import { getIsMobile } from './deviceUtils';
import { SignupEmbedder } from 'signup-embedder';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { LayoutType } from 'signup-components/types';
export const getShouldShowSidePanel = () => {
  const isEnabledByFlow = getFlowConfig().getLayoutType() === LayoutType.SidePanel;
  const isMobile = getIsMobile();
  const isEmbedded = SignupEmbedder.isActive();
  if (isMobile || isEmbedded) {
    return false;
  }
  return isEnabledByFlow;
};